import React, { useEffect, useState } from "react";
import { 
  BarChart, Bar, XAxis, YAxis, CartesianGrid, 
  Tooltip, ResponsiveContainer, Cell, LabelList 
} from "recharts";
import { Spinner, Card } from "react-bootstrap";
import { FiTrendingUp } from "react-icons/fi";

const BarreOrdiniOggi = () => {
  const [dataGrafico, setDataGrafico] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("./ordini_urgenti.json")
      .then((res) => res.json())
      .then((data) => {
        const ordini = data?.ORDINI_OGGI?.flat() || [];
        
        let sommaOF4G = 0;
        let sommaAltri = 0;

        ordini.forEach(item => {
          const valore = parseFloat(item.importo_doc) || 0;
          if (item.tipo_doc === "OF4G") {
            sommaOF4G += valore;
          } else {
            sommaAltri += valore;
          }
        });

        setDataGrafico([
          { name: "URGENTI", totale: sommaOF4G, color: "#b81f25" },
          { name: "STANDARD", totale: sommaAltri, color: "#adb5bd" }
        ]);
        
        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore fetch dati:", err);
        setLoading(false);
      });
  }, []);

// Sostituisci la tua funzione attuale con questa:
const formatEuro = (value) => 
  new Intl.NumberFormat('it-IT', { 
    style: 'currency', 
    currency: 'EUR', 
    minimumFractionDigits: 2, // Forza la presenza di 2 decimali (es. ,00)
    maximumFractionDigits: 2  // Arrotonda al massimo a 2 decimali
  }).format(value);
  return (
    <Card className="border-0 card shadow-lg overflow-hidden" style={{ borderRadius: '16px', height: '400px', background: '#fff' }}>
      {/* Header */}
      <div className="p-3 bg-light border-bottom d-flex justify-content-between align-items-center">
        <h6 className="m-0 fw-bold text-secondary" style={{ letterSpacing: '0.5px', fontSize: '0.75rem' }}>
          VOLUME VENDITE PER TIPO
        </h6>
        <FiTrendingUp className="text-secondary" />
      </div>

      <Card.Body className="d-flex flex-column p-4">
        {loading ? (
          <div className="d-flex justify-content-center align-items-center flex-grow-1">
            <Spinner animation="border" variant="danger" />
          </div>
        ) : (
          <>
            <div className="flex-grow-1 w-100">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart
                  layout="vertical"
                  data={dataGrafico}
                  margin={{ top: 20, right: 60, left: 20, bottom: 20 }}
                >
                  <XAxis type="number" hide />
                  <YAxis 
                    dataKey="name" 
                    type="category" 
                    stroke="#6c757d" 
                    fontSize={11} 
                    fontWeight={700}
                    tickLine={false}
                    axisLine={false}
                  />
                  <Tooltip 
                    cursor={{ fill: '#f8f9fa' }}
                    contentStyle={{ borderRadius: '10px', border: 'none', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}
                    formatter={(value) => [formatEuro(value), "Totale"]}
                  />
                  <Bar dataKey="totale" radius={[0, 10, 10, 0]} barSize={45}>
                    {dataGrafico.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                    <LabelList 
                      dataKey="totale" 
                      position="right" 
                      formatter={formatEuro} 
                      style={{ fontSize: '0.8rem', fontWeight: 'bold', fill: '#333' }} 
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>

            {/* Footer con i totali chiari */}
            <div className="mt-4 p-3 rounded-3 bg-light d-flex justify-content-around">
              <div className="text-center">
                <div className="text-muted text-uppercase mb-1" style={{ fontSize: '0.6rem', fontWeight: '800' }}>Urgenti</div>
                <div className="fw-bold" style={{ color: "#b81f25", fontSize: '1.1rem' }}>{formatEuro(dataGrafico[0].totale)}</div>
              </div>
              <div style={{ width: '1px', background: '#dee2e6' }}></div>
              <div className="text-center">
                <div className="text-muted text-uppercase mb-1" style={{ fontSize: '0.6rem', fontWeight: '800' }}>Standard</div>
                <div className="fw-bold" style={{ color: "#444", fontSize: '1.1rem' }}>{formatEuro(dataGrafico[1].totale)}</div>
              </div>
            </div>
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default BarreOrdiniOggi;